/**
 * Checks if the dateFrom for the product is set
 * If not, redirect to Step 1 of that flow.
 */
export default defineNuxtRouteMiddleware((to) => {
    const { isFeatureEnabled } = useFeatureFlags();
    const { product } = useProduct(to);
    const feature = `products.${product.value.config.key}` as FeatureFlag;
    if (!isFeatureEnabled(feature)) {
        return abortNavigation();
    }
});
